import React, { useState } from 'react';
import SearchIcon from "@mui/icons-material/Search";
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    TextField,
    Link,
    Button,
    Dropdown,
    Menu,
    MoreOutlined,
} from '@mui/material';

import appColors from '../config/appColors';
import { Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import SwapVert from "@mui/icons-material/SwapVert";

const AgreementDataTable = ({ data, columns }) => {

    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState('');
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });

    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
    };

    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    const sortedData = [...data].sort((a, b) => {
        if (sortConfig.key !== null) {
            if (a[sortConfig.key] < b[sortConfig.key]) {
                return sortConfig.direction === 'ascending' ? -1 : 1;
            }
            if (a[sortConfig.key] > b[sortConfig.key]) {
                return sortConfig.direction === 'ascending' ? 1 : -1;
            }
        }
        return 0;
    });

    const filteredData = sortedData.filter((item) =>
        Object.values(item).some(
            (value) => typeof value === 'string' && value.toLowerCase().includes(searchTerm.toLowerCase())
        )
    );

    const getBgColor = (row) => {
        if (row.agreement_status == 'sign_pending') return appColors.primaryLight;
        if (row.agreement_status == 'deleted') return 'rgba(0,0,0,0.5)';
        let endDate = new Date(row.expected_end_date);
        let today = new Date();
        let bgColor = 'white';
        // if (row.extended_date) endDate = row.extended_date;
        let daysRemaining = Math.ceil((endDate - today) / (1000 * 60 * 60 * 24));
        if (row.agreement_status == 'closed') return appColors.success
        if (daysRemaining <= 0) {
            console.log('row', row);
            bgColor = appColors.red;
        }
        else if (daysRemaining <= 2) {
            bgColor = appColors.yellow;
        }
        return bgColor;
    }


    return (
        <div style={{ width: "98%", }}>


            {/* <div className="searchBar-Container" style={{ marginTop: 10, marginLeft: 0, }}  >
                <div style={{ width: 1.5, height: '15px', backgroundColor: appColors.primary, marginTop: 3 }} />
                <input
                    onChange={handleSearch}
                    placeholder="Search"
                    style={{ border: "none", fontFamily: 'Poppins', marginLeft: 5, outline: "none", width: "100%", height: "100%", backgroundColor: "transparent", fontSize: 13 }} />
                <SearchIcon style={{ color: appColors.primary, fontSize: 20 }} />
            </div> */}
            <div className="searchBar-Container" style={{ marginTop: 10, marginLeft: 0, display: 'flex', flexDirection: 'row', width: "50%", backgroundColor: '#ebe8e8ff', height: 49, borderRadius: 10, alignItems: 'center', paddingRight: 10, paddingLeft: 10 }}  >
                <div style={{ width: 1.5, height: '15px', backgroundColor: appColors.primary, marginTop: 3 }} />
                <input
                    onChange={handleSearch}
                    placeholder="Search"
                    style={{ border: "none", fontFamily: 'Poppins', marginLeft: 5, outline: "none", width: "100%", height: "100%", backgroundColor: "transparent", fontSize: 13 }} />
                <SearchIcon style={{ color: appColors.primary, fontSize: 20 }} />

            </div>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: 15, width: "100%" }}>
                <div style={{ flexDirection: 'row', display: 'flex', }}>
                    <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                        <div style={{ width: 30, height: 20, borderRadius: 4, backgroundColor: appColors.primaryLight, }} />
                        <Typography style={{ fontFamily: 'Poppins', fontSize: 8, color: 'black', marginTop: 2 }}>Sign pending</Typography>
                    </div>
                    <div style={{ marginLeft: 5, display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                        <div style={{ width: 30, height: 20, borderRadius: 4, backgroundColor: appColors.yellow, }} />
                        <Typography style={{ fontFamily: 'Poppins', fontSize: 8, color: 'black', marginTop: 2 }}>Contract ending</Typography>
                    </div>
                    <div style={{ marginLeft: 5, display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                        <div style={{ width: 30, height: 20, borderRadius: 4, backgroundColor: appColors.red, }} />
                        <Typography style={{ fontFamily: 'Poppins', fontSize: 8, color: 'black', marginTop: 2 }}>Contract ends</Typography>
                    </div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <Button
                        onClick={() => navigate('/new-agreement')}
                        style={{ backgroundColor: appColors.primary, color: 'white', fontFamily: 'Poppins', fontSize: 12, textTransform: 'none' }}
                        variant="contained"
                    >Add new agreement</Button>
                </div>
            </div>


            <TableContainer
                style={{ marginTop: 10 }}
                component={Paper}
            >
                <Table>
                    <TableHead style={{ backgroundColor: appColors.dataTableHeader }}>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell
                                    style={{ fontFamily: 'Poppins', fontSize: 14, color: 'black' }}
                                    key={column.key} onClick={() => handleSort(column.dataIndex)}>
                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                        {column.title}
                                        <SwapVert style={{ fontSize: 15 }} />
                                    </div>
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredData.map((row, index) => {
                            return (
                                <TableRow

                                    style={{ backgroundColor: getBgColor(row) }}
                                    key={index}>
                                    {columns.map((column) => (
                                        <TableCell
                                            style={{ fontFamily: 'Poppins', fontSize: 12, color: 'black' }}
                                            key={column.key}>
                                            {column.render ? column.render(row[column.dataIndex], row) : row[column.dataIndex]}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
};

export default AgreementDataTable;
